export const paymentHistory = [
  ['Date', 'Description', 'Amount', 'Status'],
  [{
    Date: '11/22/01',
    Description: 'Standard',
    Amount: '$ S',
    Status: 'Paid',
  },
  {
    Date: '11/22/01',
    Description: 'Standard',
    Amount: '$ S',
    Status: 'Paid',
  },
  {
    Date: '11/22/01',
    Description: 'Standard',
    Amount: '$ S',
    Status: 'Paid',
  }],
];

export const nextbillingDay = [
  ['Date', 'Description', 'Amount', 'Status'],
  [{
    Date: '11/22/01',
    Description: 'Standard',
    Amount: '$ S',
    Status: 'Paid',
  }],
];



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/Chart/config.js